export enum CollabSessionSaveResult {
  AlreadySaving,
  MoreToSave,
  NothingToSave,
  NotLoaded,
  Saved,
  SessionStopped,
  UnableToSave
}
